import { Slide } from '@/components/core/Slide';
import audioFile from './22-ar-installations.mp3';
import videoFile from './22-electric-ar-plan.webm';

const autoNextDuration = 54000;
const transcript = `
  Ik kan ook leidingen intekenen en technologieën als augmented reality maken het mogelijk om dit allemaal 
  realtime op locatie te kunnen zien.

  Stel je voor: een installateur draagt een Augmented Reality-bril en kan direct zien waar leidingen, kabels en andere 
  technische componenten moeten komen, zonder constant naar papieren tekeningen te hoeven kijken.

  Dit maakt alles erg overzichtelijk en duidelijk voor installateurs en andere professionals op de bouwplaats.

  Ze kunnen in één oogopslag zien waar elektra, water, en ventilatie moet komen, en hoe deze systemen 
  met elkaar verbonden zijn.

  Dit vermindert fouten, versnelt het installatieproces en maakt het mogelijk om complexe installaties 
  efficiënter uit te voeren.

  Ik ben al even aan het woord; Wil jij daar nog wat aan toevoegen Jonathan? Hoe kijk jij hiernaar?
`;

// Jonathan: [verteld over mobiele telefoons en AR, hoe monteurs dit kunnen gebruiken met AI vision]

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10 text-white">👓 AR voor Installaties</h1>
      </div>
    </Slide>
  );
};
